import axios, { type AxiosInstance } from 'axios'

const DEFAULT_TIMEOUT = 30000

/**
 * How long a final audit's finalize or a transfer's receive is given. A large
 * one outlasts the default, and a client that gives up first leaves the user
 * guessing whether it happened (web-portal#97). It sits above api-core's own
 * 60-second write timeout, so the server always answers first.
 */
export const LONG_WRITE_TIMEOUT_MS = 120000

export function createHttpClient(baseURL: string, timeout = DEFAULT_TIMEOUT): AxiosInstance {
  return axios.create({
    baseURL,
    timeout,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
